import { gql } from "@apollo/client";

export const PERSON_WORKPLACES_QUERY = gql`
  query personWorkplaces($partnerId: Int!) {
    personWorkplaces(partnerId: $partnerId) {
      personWorkplaceId
      professionId
      positionId
      employerId
      dateFrom
      dateTo
    }
  }
`;

export const PROFESSIONS_QUERY = gql`
  query professions {
    professions {
      professionId
      professionName
    }
  }
`;

export const POSITIONS_QUERY = gql`
  query positions {
    positions {
      positionId
      positionName
    }
  }
`;

export const EMPLOYERS_QUERY = gql`
  query employers {
    employers {
      employerId
      employerName
    }
  }
`;
